export default function openAdvancedSearch() {
    gd.goTo('search');
}
